module.exports = __webpack_public_path__ + "static/media/piel_naranja.882b6e4a.jpg";